export const TARGET_TYPE = {
  SELF: '_self',
  BLANK: '_blank'
}
